import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPromoCodeCloseIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	width: 15,
	height: 15,
	viewBox: "0 0 20 20",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip-path",
			children: /* @__PURE__ */ _jsx("rect", {
				id: "Rectangle_3852",
				"data-name": "Rectangle 3852",
				width: 20,
				height: 20,
				fill: "#000000"
			})
		}) }),
		/* @__PURE__ */ _jsx("g", {
			id: "Group_7810",
			"data-name": "Group 7810",
			clipPath: "url(#clip-path)",
			children: /* @__PURE__ */ _jsx("path", {
				id: "Path_19333",
				"data-name": "Path 19333",
				d: "M10,0A10,10,0,1,0,20,10,9.991,9.991,0,0,0,10,0m4.3,14.3a1,1,0,0,1-1.41,0L10,11.41,7.11,14.3A1,1,0,0,1,5.7,12.89L8.59,10,5.7,7.11A1,1,0,0,1,7.11,5.7L10,8.59,12.89,5.7A1,1,0,0,1,14.3,7.11L11.41,10l2.89,2.89a1.014,1.014,0,0,1,0,1.41",
				fill: "#000000"
			})
		})
	]
});
const ForwardRef = forwardRef(SvgPromoCodeCloseIcon);
export default ForwardRef;
